module.exports = __webpack_public_path__ + "media/PeeledOrange.e39be6d4.mp4";